<template>
  <div class="gameScreen">
    <GlobalEvents @keydown="tester($event)"></GlobalEvents>
    <MyButton class="btn" :btnIcon="'close'" :rad="'50%'" @click.native="close"></MyButton>
    <div class="btn-group">
      <MyButton class="sidebtn" @click.native="playPause" :rad="'10px'" :btnIcon="icon"></MyButton>
    </div>

    <MyCheckBox @toggler="modeToggle"></MyCheckBox>
    <div class="canvas" ref="canvas">
      <span class="path" v-for="i in 756" :key="i"></span>
    </div>
    <div class="scoreBoard">
      {{score}}
    </div>

    <MyInput class="name-input" :userScore="score" :scoreSaved="scoreSaved" v-if="showNameField"></MyInput>
  </div>
</template>

<script>
import MyButton from "@/components/MyButton";
import GlobalEvents from 'vue-global-events';
import MyInput from "@/components/MyInput";
import MyCheckBox from "@/components/MyCheckBox";

export default {
  name: "GameScreen",
  props: ['gameToggle'],
  components:{
    MyButton: MyButton,
    GlobalEvents: GlobalEvents,
    MyInput: MyInput,
    MyCheckBox: MyCheckBox
  },
  data(){
    return{
      confined: false,
      row:21,
      col:36,
      snake:{
        arr:[55,56,57,58],
      },
      fruit:684,
      speed:150,
      direction:'ArrowRight',
      inter: null,
      lastKey: '',
      started:false,
      painted:false,
      icon:'play_arrow',
      score: 0,
      showNameField: false,
    }
  },
  methods:{
    modeToggle(e){
      // console.log(e)
      this.confined = e
      let box = document.querySelector('#snake').classList
      if (e){
        box.add('confined')
      } else {
        box.remove('confined')
      }
      this.score = 0
      this.gameOver()
      this.icon = 'play_arrow'

    },
    close(){
      clearInterval(this.inter)
      this.gameToggle()
    },
    playPause(){
      if(!this.started && !this.painted){
        this.start()
        this.painted = true
        this.icon = 'play_arrow'
      } else if(!this.started){
        this.tester({code:this.direction})
        this.icon = 'pause'
      } else {
        clearInterval(this.inter)
        this.started = false
        this.painted = true
        this.icon = 'play_arrow'
      }
    },
    tester(e){
      if(['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'].includes(e.code)){
        this.direction = e.code

        if(this.direction === 'ArrowUp' && this.lastKey === 'ArrowDown'){
          this.direction = this.lastKey
        } else if(this.direction === 'ArrowDown' && this.lastKey === 'ArrowUp'){
          this.direction = this.lastKey
        } else if(this.direction === 'ArrowLeft' && this.lastKey === 'ArrowRight'){
          this.direction = this.lastKey
        } else if(this.direction === 'ArrowRight' && this.lastKey === 'ArrowLeft'){
          this.direction = this.lastKey
        }

        if(!this.started && !this.painted){
          this.start()
          this.painted = true
        } else if(!this.started){
          this.start()
          this.scoreSaved()
          this.inter = setInterval(() => this.snakeLogic(this.direction), this.speed)
          this.started = true
          this.icon = 'pause'
        }
      }
    },
    keyHandler(){
      let newPos
      switch (this.direction) {

        case "ArrowRight":
          newPos = this.snake.arr[this.snake.arr.length - 1] + 1
          if((newPos-1) % 36 === 0){
            if (this.confined){
              this.gameOver()
              return 'over'
            } else {
              newPos = newPos - 36
            }

          } break
        case "ArrowLeft":
          newPos = this.snake.arr[this.snake.arr.length - 1] - 1
          if( (newPos + 36) % 36 === 0){
            if (this.confined){
              this.gameOver()
              return 'over'
            } else {
              newPos = newPos + 36
            }
          } break
        case "ArrowUp":
          newPos = this.snake.arr[this.snake.arr.length - 1] - 36
          if(newPos <= 0){
            if (this.confined){
              this.gameOver()
              return 'over'
            } else {
            newPos = 756 + newPos
              }
          } break
        case "ArrowDown":
          newPos = this.snake.arr[this.snake.arr.length - 1] + 36
          if(newPos > 756){
            if (this.confined){
              this.gameOver()
              return 'over'
            } else {
              newPos = newPos - 756
            }
          } break
      }
      return newPos
    },

    snakeLogic(){
      let newPos = this.keyHandler()

      if(newPos !== 'over'){
        if(this.fruit !== newPos){
          this.snake.arr.shift()
        } else {
          this.addFruit()
          this.score++
        }

        if (this.snake.arr.includes(this.fruit)){
          this.addFruit()
        }

        if(this.snake.arr.includes(newPos)){
          this.gameOver()
        } else {
          this.snake.arr.push(newPos)
          this.start()
          this.lastKey = this.direction
        }
      }


    },
    start(){
      if(!this.painted && !this.started){
        this.placeSnake(this.randomer(756))
        this.addFruit()
      }

      this.clearSnake()
      this.addSnake()
    },
    gameOver(){
      clearInterval(this.inter)
      if (this.started){
        this.painted = false
      }
      this.started = false

      this.icon = 'refresh'
      this.direction = 'ArrowRight'
      this.lastKey = ''

      if(this.score > 50){
        let localScore = JSON.parse(localStorage.getItem('User Score')) !== null ?
            JSON.parse(localStorage.getItem('User Score')):
            []
          if(localScore.length < 3){
            this.showNameField = true
          } else {
            localScore.forEach(entry => {
              if (this.score > entry.score){
                this.showNameField = true
              }
            })
          }

      }

    },
    scoreSaved(){
      this.showNameField = false
      this.score = 0
    },
    clearSnake(){
      document.querySelectorAll('.snake').forEach(el => {
        el.classList.remove('snake')
        el.classList.remove('head')
      })
    },
    addSnake(){
      for (let i = 0; i< this.snake.arr.length; i++){
        document.querySelector('.path[pos="'+this.snake.arr[i]+'"]').classList.add('snake')
        if (i === (this.snake.arr.length -1)){
          document.querySelector('.path[pos="'+this.snake.arr[i]+'"]').classList.add('head')
        }
      }
    },
    randomer(max){
      return Math.floor(Math.random()*max + 1)
    },

    addFruit(){
      if (document.querySelector('.fruit') !== null){
        document.querySelector('.fruit').classList.remove('fruit')
      }
      let pos = 1
      do {
        pos = this.randomer(756)
      } while (this.snake.arr.includes(pos))
      this.fruit = pos
      // document.querySelector('.fruit').classList.remove('.fruit')
      document.querySelector('.path[pos="'+pos+'"]').classList.add('fruit')
    },

    placeSnake(head){

      this.snake.arr=[]
      if(head % 36 < 4){
        head = head + 4
      }
      for(let i = 0; i< 4; i++){
        this.snake.arr.unshift(head - i)
      }
      
    }

  },
  mounted() {
    let myChild = this.$refs.canvas.children
    for(let i = 1; i<= myChild.length; i++){
      myChild.item(i-1).setAttribute('pos',i.toString())
    }
    this.start()
    this.painted = true
  },
  beforeDestroy() {
    document.querySelector('#snake').classList.remove('confined')
  }
}
</script>

<style>
.gameScreen{
  position: relative;
  width: 100%;
  height: 100%;
}

.canvas{
  width: 100%;
  height: 100%;
  border-radius: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.path{
  width: 20px;
  height: 20px;
  /*background-color: #515151;*/
  margin: 1px;
}

.name-input{
  position: relative;
  margin: 20px;
}

.snake{
  background-color: var(--snake);
  border-radius: 3px;
  box-shadow: var(--snake-shadow);
}

.head{
  background-color: var(--snake-head);
}

.fruit{
  background-color: #d72323;
  border-radius: 50%;
  box-shadow: var(--snake-shadow);
}

.bulletinBoard{
  position: relative;
  top: -60px;
  font-size: 18px;
  color: #e2e2e2;
  text-align: center;
}

.btn{
  position: absolute;
  right: -70px;
  top: -70px;
  margin: 10px!important;
}

.btn-group{
  position: absolute;
  right: -100px;
  top: calc(50% + 10px);
}

.scoreBoard{
  position: absolute;
  right: -80px;
  top: calc(50% - 90px);
  width: 40px;
  height: 40px;
  display: flex;
  box-shadow: var(--shadow);
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: var(--color);
  border-radius: 10px;
}

</style>